import Vue from 'vue'
import Vuex from 'vuex'
import lang from './modules/lang'
import request from './modules/request'
import notification from './modules/notification'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    request,
    lang,
    notification
  }
})
